import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  de: {
    // Navigation
    dashboard: 'Dashboard',
    employees: 'Mitarbeiter',
    payroll: 'Lohnabrechnung',
    advances: 'Vorschüsse',
    loans: 'Kredite',
    recurring: 'Wiederkehrend',
    export: 'Export',
    archive: 'Archiv',
    users: 'Benutzer',
    auditLog: 'Protokoll',
    settings: 'Einstellungen',
    logout: 'Abmelden',
    
    // Common
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    search: 'Suchen',
    filter: 'Filtern',
    actions: 'Aktionen',
    status: 'Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    open: 'Offen',
    closed: 'Geschlossen',
    draft: 'Entwurf',
    finalized: 'Finalisiert',
    loading: 'Laden...',
    noData: 'Keine Daten',
    confirm: 'Bestätigen',
    yes: 'Ja',
    no: 'Nein',
    
    // Login
    login: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    loginTitle: 'Lohnvorbereitung System',
    loginSubtitle: 'Pre-Lohnabrechnung für Mitarbeiter in Tunesien',
    invalidCredentials: 'Ungültige Anmeldedaten',
    
    // Dashboard
    totalEmployees: 'Gesamt Mitarbeiter',
    totalGrossThisMonth: 'Brutto diesen Monat',
    totalNetThisMonth: 'Netto diesen Monat',
    socialTaxThisMonth: 'Sozial- & Steuerabgaben',
    grossMinusNet: 'Brutto minus Netto',
    notYetEntered: 'Noch nicht eingegeben',
    entered: 'eingegeben',
    openAdvances: 'Offene Vorschüsse',
    loanBalance: 'Kredit Saldo',
    draftPayrolls: 'Entwürfe',
    warnings: 'Warnungen',
    recentActivity: 'Letzte Aktivitäten',
    monthlyOverview: 'Monatsübersicht',
    selectedPeriod: 'Ausgewählter Zeitraum',
    monthlyDetails: 'Monatsdetails',
    hoursOverview: 'Stunden Übersicht',
    leaveOverview: 'Urlaub/Krankheit',
    bonusOverview: 'Bonus Übersicht',
    deductionsOverview: 'Abzüge Übersicht',
    totalDeductions: 'Gesamt Abzüge',
    employeesInPayroll: 'Mitarbeiter in Lohnabrechnung',
    noDataForPeriod: 'Keine Daten für diesen Zeitraum',
    
    // Employee
    newEmployee: 'Neuer Mitarbeiter',
    editEmployee: 'Mitarbeiter bearbeiten',
    firstName: 'Vorname',
    lastName: 'Nachname',
    gender: 'Geschlecht',
    male: 'Männlich',
    female: 'Weiblich',
    employeeId: 'Mitarbeiter-ID',
    idCardNumber: 'Ausweis-Nr.',
    idCardIssueDate: 'Ausstellungsdatum Ausweis',
    socialSecurityNumber: 'Sozialversicherungsnummer',
    birthDate: 'Geburtsdatum',
    address: 'Adresse',
    phone: 'Telefon',
    email: 'E-Mail',
    position: 'Position',
    department: 'Abteilung',
    contractType: 'Vertragsart',
    fulltime: 'Vollzeit',
    parttime: 'Teilzeit',
    freelancer: 'Freelancer',
    minijob: 'Minijob',
    temporary: 'Befristet',
    startDate: 'Eintrittsdatum',
    endDate: 'Enddatum',
    edit: 'Bearbeiten',
    finalize: 'Finalisieren',
    requiredFieldsMissing: 'Pflichtfelder fehlen',
    workHoursPerWeek: 'Arbeitsstunden/Woche',
    standardDailyHours: 'Standard Tagesstunden',
    hourlyRate: 'Stundenlohn',
    monthlyFixedSalary: 'Monatliches Fixgehalt',
    standardBonus: 'Standard Bonus',
    overtimeSurcharge: 'Überstundenzuschlag %',
    nightSurcharge: 'Nachtzuschlag %',
    holidaySurcharge: 'Feiertagszuschlag %',
    weekendSurcharge: 'Wochenendzuschlag %',
    otherSurcharge: 'Sonstige Zuschläge %',
    currency: 'Währung',
    vacationDaysPerYear: 'Urlaubstage/Jahr',
    vacationDaysTaken: 'Genommene Urlaubstage',
    vacationDaysRemaining: 'Resturlaub',
    terminationDate: 'Kündigungsdatum',
    personalData: 'Persönliche Daten',
    contractData: 'Vertragsdaten',
    salaryData: 'Gehaltsdaten',
    vacationManagement: 'Urlaubsverwaltung',
    documents: 'Dokumente',
    uploadDocument: 'Dokument hochladen',
    documentType: 'Dokumenttyp',
    contract: 'Vertrag',
    idCard: 'Ausweis',
    socialSecurity: 'Sozialversicherung',
    other: 'Sonstiges',
    resignationLetter: 'Kündigungsschreiben erstellen',
    resignationLetterTooltip: 'PDF Kündigungsschreiben (Lettre de démission) generieren',
    soldeToutCompte: 'Solde de tout compte',
    soldeToutCompteTooltip: 'Abschlusszahlung-Dokument generieren',
    soldeToutCompteTitle: 'Solde de tout compte erstellen',
    amountDinar: 'Betrag (Dinar)',
    amountPlaceholder: 'z.B. 1500.000',
    generateDocument: 'Dokument erstellen',
    print: 'Drucken',
    attestationTravail: 'Attestation erstellen',
    attestationTravailTooltip: 'Arbeitsbescheinigung (Attestation de travail) generieren',
    contratFreelance: 'Freelancer Vertrag',
    contratFreelanceTooltip: 'Contrat de prestation de service generieren',
    
    // Bank Details
    bankDetails: 'Bankdaten',
    bankName: 'Bank Name',
    bankIban: 'IBAN / RIB',
    bankBic: 'BIC / SWIFT',
    
    // Payroll
    newPayroll: 'Neue Abrechnung',
    payrollPeriod: 'Abrechnungszeitraum',
    periodStart: 'Von',
    periodEnd: 'Bis',
    regularHours: 'Reguläre Stunden',
    overtimeHours: 'Überstunden',
    nightHours: 'Nachtstunden',
    holidayHours: 'Feiertagsstunden',
    weekendHours: 'Wochenendstunden',
    vacationDays: 'Urlaubstage',
    sickDays: 'Krankheitstage',
    sickPay: 'Krankengeld',
    oneTimeBonus: 'Einmalbonus',
    commission: 'Provision',
    specialPayments: 'Sonderzahlungen',
    advanceDeduction: 'Vorschuss Abzug',
    loanDeduction: 'Kredit Abzug',
    baseGross: 'Grundbrutto',
    totalSurcharges: 'Gesamt Zuschläge',
    totalBonus: 'Gesamt Bonus',
    vacationPay: 'Urlaubsgeld',
    recurringAdditions: 'Wiederkehrende Zulagen',
    recurringDeductions: 'Wiederkehrende Abzüge',
    totalGross: 'Gesamt Brutto',
    payoutGross: 'Auszahlung Brutto',
    payoutNet: 'Auszahlung Netto',
    finalize: 'Finalisieren',
    carryOverInfo: 'Übernahme aus Vormonaten',
    suggestedDeductions: 'Vorgeschlagene Abzüge',
    monthYear: 'Monat/Jahr',
    quickSelect: 'Schnellauswahl',
    allMonths: 'Alle Monate',
    allEmployees: 'Alle Mitarbeiter',
    allStatuses: 'Alle Status',
    clearFilters: 'Filter löschen',
    filterResults: 'Gefilterte Ergebnisse',
    entries: 'Einträge',
    noDataForFilter: 'Keine Daten für diesen Filter',
    employee: 'Mitarbeiter',
    viewDetails: 'Details anzeigen',
    downloadPdf: 'PDF herunterladen',
    
    // Tax Advisor Section
    taxAdvisorSection: 'Steuerberater Bereich',
    netSalary: 'Netto-Lohn',
    enterNetSalary: 'Netto-Lohn eingeben (TND)',
    savedNetSalary: 'Gespeicherter Netto-Lohn',
    finalPayout: 'Finale Auszahlung',
    netSalaryIncludesDeductions: '* Abzüge (Kredit/Vorschuss) bereits vom Steuerberater berücksichtigt',
    finalDocument: 'Finale Lohnabrechnung',
    uploadFinalDocument: 'Finale Lohnabrechnung vom Steuerberater hochladen',
    selectFile: 'Datei auswählen',
    documentUploaded: 'Dokument erfolgreich hochgeladen',
    documentDeleted: 'Dokument gelöscht',
    confirmDeleteDocument: 'Möchten Sie dieses Dokument wirklich löschen?',
    uploadedBy: 'Hochgeladen von',
    updatedBy: 'Aktualisiert von',
    pleaseEnterValidAmount: 'Bitte geben Sie einen gültigen Betrag ein',
    invalidFileType: 'Ungültiger Dateityp. Erlaubt: PDF, PNG, JPG',
    
    // Advances & Loans
    newAdvance: 'Neuer Vorschuss',
    amount: 'Betrag',
    remainingAmount: 'Restbetrag',
    date: 'Datum',
    notes: 'Notizen',
    deduct: 'Abziehen',
    newLoan: 'Neuer Kredit',
    totalAmount: 'Gesamtbetrag',
    monthlyRate: 'Monatliche Rate',
    payment: 'Zahlung',
    
    // Recurring
    newRecurringItem: 'Neuer wiederkehrender Posten',
    itemType: 'Postenart',
    deduction: 'Abzug',
    addition: 'Zulage',
    name: 'Bezeichnung',
    percentage: 'Prozent',
    startMonth: 'Startmonat',
    endMonth: 'Endmonat',
    deactivate: 'Deaktivieren',
    
    // Export
    exportPdf: 'PDF Export',
    exportExcel: 'Excel Export',
    sendEmail: 'E-Mail senden',
    recipientEmail: 'Empfänger E-Mail',
    subject: 'Betreff',
    message: 'Nachricht',
    attachPayrolls: 'Abrechnungen anhängen',
    
    // Users
    newUser: 'Neuer Benutzer',
    role: 'Rolle',
    admin: 'Administrator',
    hr: 'HR',
    viewer: 'Betrachter',
    fullName: 'Vollständiger Name',
    toggleActive: 'Status ändern',
    
    // Warnings
    missingSsn: 'Fehlende Sozialversicherungsnummer',
    missingIdCard: 'Fehlende Ausweis-Nr.',
    negativeVacation: 'Negative Urlaubstage',
    openAdvanceWarning: 'Offener Vorschuss',
    draftPayrollWarning: 'Entwurf Abrechnung',
    
    // Messages
    savedSuccessfully: 'Erfolgreich gespeichert',
    deletedSuccessfully: 'Erfolgreich gelöscht',
    errorOccurred: 'Ein Fehler ist aufgetreten',
    confirmDelete: 'Möchten Sie wirklich löschen?',
    confirmFinalize: 'Möchten Sie die Abrechnung finalisieren?',
    emailSent: 'E-Mail erfolgreich gesendet',
    smtpNotConfigured: 'SMTP nicht konfiguriert',
    loadingError: 'Fehler beim Laden',
    updatedSuccessfully: 'Erfolgreich aktualisiert',
    
    // Payroll Edit
    editPayroll: 'Lohnabrechnung bearbeiten',
    cannotEditFinalized: 'Finalisierte Lohnabrechnungen können nicht bearbeitet werden',
    employeeCannotBeChanged: 'Mitarbeiter kann nicht geändert werden',
    saveChanges: 'Änderungen speichern',
    
    // Delete confirmations
    confirmDeleteAdvance: 'Sind Sie sicher, dass Sie diesen Vorschuss löschen möchten?',
    confirmDeleteLoan: 'Sind Sie sicher, dass Sie dieses Darlehen löschen möchten?',
    confirmDeletePayroll: 'Sind Sie sicher, dass Sie diese Lohnabrechnung löschen möchten?',
    confirmDeleteEmployee: 'Sind Sie sicher, dass Sie diesen Mitarbeiter löschen möchten?',
    deleteOnlyAdmin: 'Löschen (nur Admin)',
    
    // Payroll Detail
    employeeData: 'Mitarbeiterdaten',
    employeeIdLabel: 'Mitarbeiter-ID',
    overtimeLabel: 'Überstunden',
    nightHoursLabel: 'Nachtstunden',
    surchargesSection: 'Zuschläge & Überstunden',
    bonusSection: 'Prämien & Bonus',
    deductionsSection: 'Abzüge',
    summarySection: 'Zusammenfassung',
    advance: 'Vorschuss',
    loan: 'Kredit',
    
    // Carry Over
    carryOverTitle: 'Übertragung / Report',
    openAdvancesTitle: 'Offene Vorschüsse',
    activeLoansTitle: 'Aktive Darlehen',
    remainingBalance: 'Restbetrag',
    suggestedRate: 'Empfohlene Rate',
    monthlyRate: 'Monatsrate',
    totalOpenAmount: 'Gesamt offen',
    totalDebt: 'Gesamt Restschuld',
    applyAsDeduction: 'Als Abzug übernehmen',
    applyTotalAmount: 'Gesamtbetrag als Abzug übernehmen',
    applyMonthlyRate: 'Monatsrate als Abzug übernehmen',
    autoDeductionNote: 'Bei Finalisierung werden die Abzüge automatisch von den offenen Beträgen abgebucht.',
    
    // Preview
    preview: 'Vorschau',
    surcharges: 'ZUSCHLÄGE',
    bonusExtras: 'BONUS & EXTRAS',
    deductions: 'ABZÜGE',
    totalSurchargesLabel: 'Gesamt Zuschläge',
    totalBonusLabel: 'Gesamt Bonus',
    totalDeductionsLabel: 'Gesamt Abzüge',
    totalGrossLabel: 'GESAMT BRUTTO',
    payoutLabel: 'AUSZAHLUNG',
    
    // Vacation
    available: 'Verfügbar',
    days: 'Tage',
    noVacationDaysRemaining: 'Keine Urlaubstage mehr verfügbar',
  },
  fr: {
    // Navigation
    dashboard: 'Tableau de bord',
    employees: 'Employés',
    payroll: 'Paie',
    advances: 'Avances',
    loans: 'Prêts',
    recurring: 'Récurrent',
    export: 'Export',
    archive: 'Archive',
    users: 'Utilisateurs',
    auditLog: 'Journal',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    
    // Common
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    search: 'Rechercher',
    filter: 'Filtrer',
    actions: 'Actions',
    status: 'Statut',
    active: 'Actif',
    inactive: 'Inactif',
    open: 'Ouvert',
    closed: 'Fermé',
    draft: 'Brouillon',
    finalized: 'Finalisé',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    
    // Login
    login: 'Connexion',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    loginTitle: 'Système de Préparation de Paie',
    loginSubtitle: 'Pré-paie pour employés en Tunisie',
    invalidCredentials: 'Identifiants invalides',
    
    // Dashboard
    totalEmployees: 'Total Employés',
    totalGrossThisMonth: 'Brut ce mois',
    totalNetThisMonth: 'Net ce mois',
    socialTaxThisMonth: 'Charges sociales & fiscales',
    grossMinusNet: 'Brut moins Net',
    notYetEntered: 'Pas encore saisi',
    entered: 'saisi',
    openAdvances: 'Avances ouvertes',
    loanBalance: 'Solde prêts',
    draftPayrolls: 'Brouillons',
    warnings: 'Avertissements',
    recentActivity: 'Activité récente',
    monthlyOverview: 'Aperçu mensuel',
    selectedPeriod: 'Période sélectionnée',
    monthlyDetails: 'Détails mensuels',
    hoursOverview: 'Aperçu des heures',
    leaveOverview: 'Congés/Maladie',
    bonusOverview: 'Aperçu bonus',
    deductionsOverview: 'Aperçu déductions',
    totalDeductions: 'Total déductions',
    employeesInPayroll: 'Employés en paie',
    noDataForPeriod: 'Aucune donnée pour cette période',
    
    // Employee
    newEmployee: 'Nouvel employé',
    editEmployee: "Modifier l'employé",
    firstName: 'Prénom',
    lastName: 'Nom',
    gender: 'Sexe',
    male: 'Masculin',
    female: 'Féminin',
    employeeId: 'ID Employé',
    idCardNumber: "N° Carte d'identité",
    idCardIssueDate: "Date de délivrance",
    socialSecurityNumber: 'Numéro de sécurité sociale',
    birthDate: 'Date de naissance',
    address: 'Adresse',
    phone: 'Téléphone',
    email: 'E-mail',
    position: 'Poste',
    department: 'Département',
    contractType: 'Type de contrat',
    fulltime: 'Temps plein',
    parttime: 'Temps partiel',
    freelancer: 'Freelance',
    minijob: 'Mini-job',
    temporary: 'Temporaire',
    startDate: "Date d'entrée",
    endDate: 'Date de fin',
    edit: 'Modifier',
    finalize: 'Finaliser',
    requiredFieldsMissing: 'Champs obligatoires manquants',
    workHoursPerWeek: 'Heures/semaine',
    standardDailyHours: 'Heures journalières',
    hourlyRate: 'Taux horaire',
    monthlyFixedSalary: 'Salaire mensuel fixe',
    standardBonus: 'Bonus standard',
    overtimeSurcharge: 'Prime heures supp. %',
    nightSurcharge: 'Prime de nuit %',
    holidaySurcharge: 'Prime jours fériés %',
    weekendSurcharge: 'Prime weekend %',
    otherSurcharge: 'Autres primes %',
    currency: 'Devise',
    vacationDaysPerYear: 'Jours de congé/an',
    vacationDaysTaken: 'Jours pris',
    vacationDaysRemaining: 'Jours restants',
    terminationDate: 'Date de résiliation',
    personalData: 'Données personnelles',
    contractData: 'Données contractuelles',
    salaryData: 'Données salariales',
    vacationManagement: 'Gestion des congés',
    documents: 'Documents',
    uploadDocument: 'Télécharger document',
    documentType: 'Type de document',
    contract: 'Contrat',
    idCard: "Carte d'identité",
    socialSecurity: 'Sécurité sociale',
    other: 'Autre',
    resignationLetter: 'Créer lettre de démission',
    resignationLetterTooltip: 'Générer une lettre de démission en PDF',
    soldeToutCompte: 'Solde de tout compte',
    soldeToutCompteTooltip: 'Générer le document de solde de tout compte',
    soldeToutCompteTitle: 'Créer solde de tout compte',
    amountDinar: 'Montant (Dinar)',
    amountPlaceholder: 'ex. 1500.000',
    generateDocument: 'Générer document',
    print: 'Imprimer',
    attestationTravail: 'Créer attestation',
    attestationTravailTooltip: 'Générer une attestation de travail en PDF',
    contratFreelance: 'Contrat Freelance',
    contratFreelanceTooltip: 'Générer un contrat de prestation de service',
    
    // Bank Details
    bankDetails: 'Coordonnées bancaires',
    bankName: 'Nom de la banque',
    bankIban: 'IBAN / RIB',
    bankBic: 'BIC / SWIFT',
    
    // Payroll
    newPayroll: 'Nouvelle paie',
    payrollPeriod: 'Période de paie',
    periodStart: 'Du',
    periodEnd: 'Au',
    regularHours: 'Heures régulières',
    overtimeHours: 'Heures supplémentaires',
    nightHours: 'Heures de nuit',
    holidayHours: 'Heures fériées',
    weekendHours: 'Heures weekend',
    vacationDays: 'Jours de congé',
    sickDays: 'Jours de maladie',
    sickPay: 'Indemnité maladie',
    oneTimeBonus: 'Bonus unique',
    commission: 'Commission',
    specialPayments: 'Paiements spéciaux',
    advanceDeduction: 'Déduction avance',
    loanDeduction: 'Déduction prêt',
    baseGross: 'Salaire de base',
    totalSurcharges: 'Total primes',
    totalBonus: 'Total bonus',
    vacationPay: 'Indemnité congé',
    recurringAdditions: 'Allocations récurrentes',
    recurringDeductions: 'Déductions récurrentes',
    totalGross: 'Total brut',
    payoutGross: 'Montant à payer brut',
    payoutNet: 'Montant à payer net',
    finalize: 'Finaliser',
    carryOverInfo: 'Report des mois précédents',
    suggestedDeductions: 'Déductions suggérées',
    monthYear: 'Mois/Année',
    quickSelect: 'Sélection rapide',
    allMonths: 'Tous les mois',
    allEmployees: 'Tous les employés',
    allStatuses: 'Tous les statuts',
    clearFilters: 'Effacer les filtres',
    filterResults: 'Résultats filtrés',
    entries: 'entrées',
    noDataForFilter: 'Aucune donnée pour ce filtre',
    employee: 'Employé',
    viewDetails: 'Voir les détails',
    downloadPdf: 'Télécharger PDF',
    
    // Tax Advisor Section
    taxAdvisorSection: 'Section Comptable',
    netSalary: 'Salaire Net',
    enterNetSalary: 'Entrer le salaire net (TND)',
    savedNetSalary: 'Salaire net enregistré',
    finalPayout: 'Paiement final',
    netSalaryIncludesDeductions: '* Déductions (prêt/avance) déjà prises en compte par le comptable',
    finalDocument: 'Fiche de paie finale',
    uploadFinalDocument: 'Télécharger la fiche de paie finale du comptable',
    selectFile: 'Sélectionner un fichier',
    documentUploaded: 'Document téléchargé avec succès',
    documentDeleted: 'Document supprimé',
    confirmDeleteDocument: 'Voulez-vous vraiment supprimer ce document?',
    uploadedBy: 'Téléchargé par',
    updatedBy: 'Mis à jour par',
    pleaseEnterValidAmount: 'Veuillez entrer un montant valide',
    invalidFileType: 'Type de fichier invalide. Autorisé: PDF, PNG, JPG',
    
    // Advances & Loans
    newAdvance: 'Nouvelle avance',
    amount: 'Montant',
    remainingAmount: 'Montant restant',
    date: 'Date',
    notes: 'Notes',
    deduct: 'Déduire',
    newLoan: 'Nouveau prêt',
    totalAmount: 'Montant total',
    monthlyRate: 'Taux mensuel',
    payment: 'Paiement',
    
    // Recurring
    newRecurringItem: 'Nouveau poste récurrent',
    itemType: 'Type de poste',
    deduction: 'Déduction',
    addition: 'Allocation',
    name: 'Nom',
    percentage: 'Pourcentage',
    startMonth: 'Mois de début',
    endMonth: 'Mois de fin',
    deactivate: 'Désactiver',
    
    // Export
    exportPdf: 'Export PDF',
    exportExcel: 'Export Excel',
    sendEmail: 'Envoyer e-mail',
    recipientEmail: 'E-mail destinataire',
    subject: 'Sujet',
    message: 'Message',
    attachPayrolls: 'Joindre les paies',
    
    // Users
    newUser: 'Nouvel utilisateur',
    role: 'Rôle',
    admin: 'Administrateur',
    hr: 'RH',
    viewer: 'Lecteur',
    fullName: 'Nom complet',
    toggleActive: 'Changer le statut',
    
    // Warnings
    missingSsn: 'Numéro de sécurité sociale manquant',
    missingIdCard: "N° carte d'identité manquant",
    negativeVacation: 'Jours de congé négatifs',
    openAdvanceWarning: 'Avance ouverte',
    draftPayrollWarning: 'Brouillon de paie',
    
    // Messages
    savedSuccessfully: 'Enregistré avec succès',
    deletedSuccessfully: 'Supprimé avec succès',
    errorOccurred: 'Une erreur est survenue',
    confirmDelete: 'Voulez-vous vraiment supprimer?',
    confirmFinalize: 'Voulez-vous finaliser la paie?',
    emailSent: 'E-mail envoyé avec succès',
    smtpNotConfigured: 'SMTP non configuré',
    loadingError: 'Erreur de chargement',
    updatedSuccessfully: 'Mis à jour avec succès',
    
    // Payroll Edit
    editPayroll: 'Modifier la paie',
    cannotEditFinalized: 'Les paies finalisées ne peuvent pas être modifiées',
    employeeCannotBeChanged: "L'employé ne peut pas être modifié",
    saveChanges: 'Enregistrer les modifications',
    
    // Delete confirmations
    confirmDeleteAdvance: 'Êtes-vous sûr de vouloir supprimer cette avance?',
    confirmDeleteLoan: 'Êtes-vous sûr de vouloir supprimer ce prêt?',
    confirmDeletePayroll: 'Êtes-vous sûr de vouloir supprimer cette paie?',
    confirmDeleteEmployee: 'Êtes-vous sûr de vouloir supprimer cet employé?',
    deleteOnlyAdmin: 'Supprimer (admin seulement)',
    
    // Payroll Detail
    employeeData: "Données de l'employé",
    employeeIdLabel: 'ID Employé',
    overtimeLabel: 'Heures supplémentaires',
    nightHoursLabel: 'Heures de nuit',
    surchargesSection: 'Primes & Heures supp.',
    bonusSection: 'Primes & Bonus',
    deductionsSection: 'Déductions',
    summarySection: 'Résumé',
    advance: 'Avance',
    loan: 'Prêt',
    
    // Carry Over
    carryOverTitle: 'Report',
    openAdvancesTitle: 'Avances ouvertes',
    activeLoansTitle: 'Prêts actifs',
    remainingBalance: 'Solde restant',
    suggestedRate: 'Taux suggéré',
    monthlyRate: 'Taux mensuel',
    totalOpenAmount: 'Total ouvert',
    totalDebt: 'Dette totale',
    applyAsDeduction: 'Appliquer comme déduction',
    applyTotalAmount: 'Appliquer le montant total',
    applyMonthlyRate: 'Appliquer le taux mensuel',
    autoDeductionNote: 'Lors de la finalisation, les déductions seront automatiquement appliquées.',
    
    // Preview
    preview: 'Aperçu',
    surcharges: 'PRIMES',
    bonusExtras: 'BONUS & EXTRAS',
    deductions: 'DÉDUCTIONS',
    totalSurchargesLabel: 'Total primes',
    totalBonusLabel: 'Total bonus',
    totalDeductionsLabel: 'Total déductions',
    totalGrossLabel: 'TOTAL BRUT',
    payoutLabel: 'À PAYER',
    
    // Vacation
    available: 'Disponible',
    days: 'jours',
    noVacationDaysRemaining: 'Plus de jours de congé disponibles',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('payroll-language');
    return saved || 'de';
  });

  useEffect(() => {
    localStorage.setItem('payroll-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'fr' : 'de');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
